<template>
  <DragZoomContainer :reset-key="stationId">
    <EssVirtual v-if="meterModel == 0" />
    <EssEntity v-if="meterModel == 1" />
  </DragZoomContainer>
</template>

<script setup>
import { computed } from 'vue'
import { useStationContext } from '@/views/station-monitor/detail/composables/useStationContext'

// 
import EssVirtual from './EssVirtual.vue'
import EssEntity from './EssEntity.vue'
import DragZoomContainer from '@/components/DragZoomContainer.vue'

const { stationId, stationName, stationBaseData } = useStationContext()
const meterModel = computed(() => {
  return stationBaseData.value.meterModel
})

</script>

<style lang="scss" src="./ess.scss"></style>
